module.exports = __webpack_public_path__ + "img/mtt_6.1.a1bf1517.png";